import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { NODE_FD3_CONTENT } from '../../../constants/constant.urls'
import { GetURL } from '../../../constants/get-url'

@Injectable({
  providedIn: 'root',
})
export class Fd3ContentService {
  constructor(private readonly http: HttpClient) {}
  public getFD3Content(): Observable<any> {
    return this.http.get<any>(GetURL(`${NODE_FD3_CONTENT}`))
  }

  public getEtfDisclosureContent(url: string): Observable<any> {
    return this.http.get<any>(url)
  }
}
